import type { DayRoomAccess } from 'app/typings/core/admin/hotel/dayRoomAccess';
import { dayjs } from 'app/utils/dayjs';

const MINUTES_IN_HOUR = 60;

export type DayRoomAccessFormValue = {
  durationHours: number;
  startTime: string;
};

export const toDayRoomAccessFormValue = (
  dayRoomAccess?: DayRoomAccess | null
): DayRoomAccessFormValue | null =>
  dayRoomAccess
    ? {
        durationHours: dayRoomAccess.durationMinutes / MINUTES_IN_HOUR,
        startTime: dayRoomAccess.startTime,
      }
    : null;

export const toDayRoomAccess = (
  formValue: DayRoomAccessFormValue
): DayRoomAccess => ({
  durationMinutes: Math.round(formValue.durationHours * MINUTES_IN_HOUR),
  startTime: formValue.startTime,
});

export const formatDayRoomAccessDuration = (durationMinutes: number) =>
  `${durationMinutes / MINUTES_IN_HOUR}h`;

export const getDayRoomAccessEndTime = (
  startTime: string,
  durationMinutes: number
) => dayjs(startTime, 'HH:mm').add(durationMinutes, 'minute').format('HH:mm');

export const formatDayRoomAccessWindow = ({
  durationMinutes,
  startTime,
}: DayRoomAccess) =>
  `${formatDayRoomAccessDuration(
    durationMinutes
  )} access (${startTime} - ${getDayRoomAccessEndTime(
    startTime,
    durationMinutes
  )})`;

export const DAY_ROOM_ACCESS_OPEN_PARAM = 'dayRoomAccessOpen';

export const getHotelDayRoomAccessPath = (hotelId: number) =>
  `/hotels/${hotelId}/edit?${DAY_ROOM_ACCESS_OPEN_PARAM}=true`;
